export enum PaxTypeEnum {
  Adult = 'Adult',
  Child = 'Child',
  Infant = 'Infant'
}

export type PaxTypeEnumType = keyof typeof PaxTypeEnum;
